import "@/components/PhotoPlaceholder/PhotoPlaceholder.scss";

/** Shown instead of a photo when a listing has none yet. Purely decorative. */
function PhotoPlaceholder() {
  return (
    <div className="photo-placeholder" aria-hidden="true">
      <svg viewBox="0 0 64 40" focusable="false">
        <path d="M2 38 L20 14 L28 24 L40 6 L62 38 Z" />
        <path
          className="photo-placeholder__snow"
          d="M40 6 L34 15 L38 14 L41 18 L44 13 L46 15 Z"
        />
      </svg>
    </div>
  );
}

export default PhotoPlaceholder;
